<template>
    <section class="carousel">
        <carousel :navigationEnabled="true"
            navigation-next-label=""
            navigation-prev-label=""
            :paginationEnabled="false"
            :scrollPerPage="false"
            :spacePadding="24"
            :perPageCustom="[
                [322, 1.1],
                [350, 1.2],
                [400, 1.2],
                [500, 1.3],
                [575, 1.7],
                [700, 2.1],
                [768, 1.8],
                [960, 2.1],
                [1024, 2.5],
                [1260, 3.5],
                [1366, 4.1],
                [1480, 4.5],
                [1540, 4.7],
                [1600, 5.1],
                [1920, 5.7],
                [2048, 6.5],
                [2560, 8.1],
            ]"
        >
            <slide v-for="(variant, index) in partnerProducts"
                :key="index"
            >
                <product-card :id="`fanshop-products-product-tile-anchor${index}`"
                    :participationAmount="getParticipationAmount(variant)"
                    :partnerId="variant.product.partnerId"
                    :productImage="getImage(variant)"
                    :productTitle="getTranslatedStr(variant, 'label', variant.label)"
                    :ssuPrice="parseInt(variant.product.sellingPrice, 10)"
                    :variantId="variant.id"
                    :redeemableAt="getRedeemableDate(variant)"
                    :variant="variant"
                />
            </slide>
        </carousel>
    </section>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
} from 'vuex';

// Components
import productCard from '@webapp/modules/rewards/components/fanshop/product-card.vue';
import {
    Carousel,
    Slide,
} from 'vue-carousel';

export default {
    name: 'product-carousel',
    components: {
        productCard,
        Carousel,
        Slide,
    },
    props: {
        partnerId: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapGetters(['getTranslatedStr']),

        ...mapGetters('partners', ['partnerById']),

        ...mapGetters('fanshop', [
            'getPartnerProducts',
            'productImagesSorted',
        ]),

        ...mapGetters('wallet', ['decentralizedLedgerByToken']),

        partnerProducts() {
            return this.getPartnerProducts(this.partner.id);
        },

        isPartnerProductsListShown() {
            return this.partnerProducts?.length;
        },

        partner() {
            if (this.partnerId) {
                return this.partnerById(this.partnerId);
            }

            return this.$route.params.id ? this.partnerById(this.$route.params.id) : {};
        },
    },
    methods: {
        productImages(variant) {
            return this.productImagesSorted(variant, false) || [];
        },

        getImage(variant) {
            return this.productImages(variant).find((image) => image.imageType.type.includes('_image_desktop_'))?.url || '';
        },

        getRedeemableDate(variant) {
            return variant?.redeemableAt || null;
        },

        getParticipationAmount(variant) {
            const partner = this.partnerById(variant.product.partnerId);
            const {
                balance,
                lockedBalance,
            } = this.decentralizedLedgerByToken(partner.currencyId);
            const balanceAmount = parseFloat(balance) + parseFloat(lockedBalance) || 0;

            if (!variant.product?.productTierLevel) {

                return 0;
            }

            return balanceAmount >= variant.product?.productTierLevel?.minTokenRequired ? 0 : variant.product?.productTierLevel?.minTokenRequired;
        },
    },
};
</script>

<style lang="scss" scoped>
.carousel {
    margin: 0 1rem;

    ::v-deep .tile {
        @include max-width(460px) {
            margin-left: 0;
        }
    }

    ::v-deep .product-tile {
        margin: 0 2rem;
    }
}
</style>